import RenderStatus from './RenderStatus';
import RenderDirection from './RenderDirection';
import  RenderDownload from './RenderDownload';

export const getAs2SummaryTableColumns=()=>{

    return [
        {
            headerName: "Id", field: "id", width: 75
        },
        {
            headerName: "Message Id", field: "messageId", width: 300
        },
        {
            headerName: "Date/Time", field: "formattedCreatedDateTime", width: 175
        },
        {
            headerName: "Status", field: "as2Status", width: 130,
            renderCell: RenderStatus
        },
        {
            headerName: "Direction", field: "directionLabel", width: 150,
            renderCell: RenderDirection
        },
        {
            headerName: "AS2 Sender Id", field: "senderAs2Id", width: 150
        },
        {
            headerName: "AS2 Receiver Id", field: "receiverAs2Id", width: 150
        },
        {
            headerName: "Supplier Num", field: "supplierNum", width: 125
        },
        {
            headerName: "Unit", field: "unit", width: 60
        },
        {
            headerName: "Envelope Key", field: "envelopeKey", width: 300
        },
        {
            headerName: "MDN Message Id", field: "mdnMessageId", width: 300
        },
        {
            headerName: "Raw File", field: "archivePath", width: 75,
            renderCell: RenderDownload,
            align: 'center'
        }

    ];
}
